<div>
    @if (isLoadingData) {
        <div class="flex justify-center">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    }
    @else {
        <p-tabs [value]="activeTab" [lazy]="true" (valueChange)="onTabChange($event)">
            <p-tablist class="overflow-hidden">
                @for (stockHistory of stockHistoryFiltered; track stockHistory.stock_id) {
                    <p-tab [value]="stockHistory.stock_id">
                        <div class="flex flex-row gap-2 items-center">
                            @if (stockHistory.is_deleted) {
                                <i class="pi pi-trash text-red-500 dark:text-red-400"></i>
                            }
                            <p-tag [severity]="utilityService.getStateSeverity(stockHistory.etat)" [value]="utilityService.getStateLabel(stockHistory.etat)" />
                            <span class="inline-block px-2 py-1 rounded-sm" [class]="utilityService.getSectorClassColor(stockHistory.secteur_nom)">{{ stockHistory.secteur_nom }}</span>
                            <code>{{ `${stockHistory.etagere} ${stockHistory.rayon}` }}</code>
                        </div>
                    </p-tab>
                }
            </p-tablist>
            <p-tabpanels class="block !p-0">
                @for (stockHistory of stockHistoryFiltered; track stockHistory.stock_id) {
                    <p-tabpanel [value]="stockHistory.stock_id">
                        <app-product-detail-historiques-stock [historiques]="stockHistory.historiques" [tabIndex]="stockHistory.stock_id" [(tabStates)]="subTabStates"></app-product-detail-historiques-stock>
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    }
</div>
